import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import ViewModal from "../../Modal";
import ProductCard from "../../Cards/ProductCard";
import { useSelector } from "react-redux";
import TrackVisitedProduct from "../../../Hooks/useTrackVisitedProduct";
 
const ProductGrid = ({
  products,
  addToCartProduct,
  addToCartBundleMain,
  addToWishListProduct,
  addToCompareListProduct,
  carts,
  removeFromCart,
  decrementQuantity,
  incrementQuantity,
  ...props
}) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };
  const [open, setOpen] = React.useState(false);

  function handleClose() {
    setOpen(false);
  }

  const [state, setState] = useState({});

  const token = useSelector((store) => store?.configs?.token);

  const handleClickOpen = (item) => {
    setOpen(true);
    setState(item);

    if (token) {
      TrackVisitedProduct({ productId: item._id, token });
    }
  }; 

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 767);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <div className={isMobile ? "grid-1" : "grid-3"}>
        {products?.length > 0 &&
          products?.map((product, index) => (
            <ProductCard
              product={product}
              key={index}
              addToWishListProduct={addToWishListProduct}
              addToCartProduct={addToCartProduct}
              addToCartBundleMain={addToCartBundleMain}
              handleClickOpen={handleClickOpen}
              removeFromCart={removeFromCart}
              decrementQuantity={decrementQuantity}
              incrementQuantity={incrementQuantity}
              carts={carts}
              {...props}
            />
          ))}
      </div>
      <ViewModal
        addToCartProduct={addToCartProduct}
        open={open}
        onClose={handleClose}
        product={state}
        carts={carts}
        incrementQuantity={incrementQuantity}
        removeFromCart={removeFromCart}
        decrementQuantity={decrementQuantity}
        {...props}
      />
    </>
  );
};

export default ProductGrid;
